exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-034cb1f8","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/ProvisionalAvatar.vue
// module id = 1072
// module chunks = 22